import { createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "../../../API/apiClient ";

export const GetPickListNum = createAsyncThunk(
    'DeliveryPickList/fetchpickListNum',
    async (_, { rejectWithValue }) => {
      try {        
        const response = await apiClient.get('DeliveryPickList/GetVehicleDetail');
        return response.data;  // Return data to be stored
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Error fetching data');
      }
    }
  );
  export const GetItem = createAsyncThunk(
    'DeliveryPickList/fetchitem',
    async ({DocEntry}, { rejectWithValue }) => {
      try {        
        const response = await apiClient.get(`DeliveryPickList/Getitem?DOCENTRY=${DocEntry}`);
        return response.data;  // Return data to be stored
      } catch (error) {
        return rejectWithValue(error.response?.data.errorMessage || 'Error fetching data');
      }
    }
  );
  export const GetDeliveryList = createAsyncThunk(
    'DeliveryPickList/fetchdeliveryList',
    async ({itemCode}, { rejectWithValue }) => {
      try {        
        const response = await apiClient.get(`DeliveryPickList/GetDelivery?ITEMCODE=${itemCode}`);
        return response.data;  // Return data to be stored
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Error fetching data');
      }
    }
  );
  export const GetDeliveryDataByBatch = createAsyncThunk(
    'DeliveryPickList/fetchDeliveryDataByBatch',
    async ({batchNumber}, { rejectWithValue }) => {
      try {        
        const response = await apiClient.get(`DeliveryPickList/GetDeliveryListByBatch?BATCHNUMBER=${batchNumber}`);
        return response.data;  // Return data to be stored
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Error fetching data');
      }
    }
  );
  export const PostDeliveryPL = createAsyncThunk(
    'DeliveryPickList/postdeliveryList',
    async (dataToPost, { rejectWithValue }) => {
      try {        
        const response = await apiClient.post(`DeliveryPickList/PickListPosting`,dataToPost);
        return response.data;  // Return data to be stored
      } catch (error) {        
        return rejectWithValue(error.response?.data.errorMessage|| error.message ||  'Error fetching Delivery List data');
      }
    }
  );